const Four0Four = () => {
  return (
    <div className="grid place-items-center h-screen w-screen">
      <p>404</p>
    </div>
  );
};

export default Four0Four;
